import React from 'react'
import { Link } from 'react-router';
import Header from '../Header';
import Sidebar from '../Sidebar';

export default function EditSupplier() {
    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            {/* <!-- Sidebar --> */}
            <Sidebar />
            {/* <!-- Main Content --> */}
            <main id="main-content" className="flex-1 px-10 py-8">
                {/* <!-- Header --> */}
                <Header title="Edit Supplier" />
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8 bg-white">
                        <div id="supplier-details-section" className="mb-8">
                            <h2 className="text-xl font-semibold mb-4 text-gray-900">
                                Supplier details
                            </h2>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="supplier-name">
                                    Supplier name
                                </label>
                                <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="supplier-name"
                                    placeholder="e.g. MediSupply Inc." type="text" />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="supplier-type">
                                    Supplier type
                                </label>
                                <select className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="supplier-type">
                                    <option value="">Select a type</option>
                                    <option value="pharmaceuticals">Pharmaceuticals</option>
                                    <option value="medical_devices">Medical Devices</option>
                                    <option value="lab_equipment">Laboratory Equipment</option>
                                    <option value="medical_consumables">Medical Consumables</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="supplier-description">
                                    Supplier description
                                </label>
                                <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 h-32" id="supplier-description"
                                    placeholder="e.g. Provider of high-quality medical equipment and supplies"></textarea>
                            </div>
                            <hr className="my-6 border-gray-200" />

                            {/* <!-- Address Section --> */}
                            <div id="address-section" className="mb-4">
                                <h2 className="text-xl font-semibold mb-4 text-gray-900">
                                    Address information
                                </h2>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="street-address">
                                        Street address
                                    </label>
                                    <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="street-address" type="text" />
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div className="mb-4">
                                        <label className="block text-gray-700 font-medium mb-2" htmlFor="city">
                                            City
                                        </label>
                                        <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="city" type="text" />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 font-medium mb-2" htmlFor="state">
                                            State/Province
                                        </label>
                                        <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="state" type="text" />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 font-medium mb-2" htmlFor="zip">
                                            ZIP/Postal code
                                        </label>
                                        <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="zip" type="text" />
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="country">
                                        Country
                                    </label>
                                    <select className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="country">
                                        <option value="">Select a country</option>
                                        <option value="us">United States</option>
                                        <option value="ca">Canada</option>
                                        <option value="uk">United Kingdom</option>
                                        <option value="au">Australia</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Contact Info Section --> */}
                        <div id="contact-info-section">
                            <h2 className="text-xl font-semibold mb-4 text-gray-900">
                                Contact info
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="first-name">
                                        First name
                                    </label>
                                    <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="first-name" placeholder="e.g. John" type="text" />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="last-name">
                                        Last name
                                    </label>
                                    <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="last-name" placeholder="e.g. Doe" type="text" />
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="email">
                                    Email address
                                </label>
                                <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="email" placeholder="e.g. john@example.com" type="email" />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="phone">
                                    Phone number
                                </label>
                                <div className="flex">
                                    <div className="relative">
                                        <select className="h-full py-3 pl-3 pr-8 border border-gray-300 bg-white rounded-l-md text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-primary-500">
                                            <option>+1</option>
                                            <option>+44</option>
                                            <option>+91</option>
                                            <option>+61</option>
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <i className="fa-solid fa-chevron-down text-xs"></i>
                                        </div>
                                    </div>
                                    <input className="flex-1 p-3 border border-gray-300 border-l-0 rounded-r-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="phone" type="tel" />
                                </div>
                            </div>
                            <div className="mb-2">
                                <label className="block text-gray-700 font-medium mb-2" htmlFor="telephone">
                                    Office telephone
                                </label>
                                <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="telephone" type="tel" />
                            </div>


                            <hr className="my-6 border-gray-200" />

                            {/* <!-- Additional Information --> */}
                            <div id="additional-info-section">
                                <h2 className="text-xl font-semibold mb-4 text-gray-900">
                                    Additional information
                                </h2>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="payment-terms">
                                        Payment terms
                                    </label>
                                    <select className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="payment-terms">
                                        <option value="">Select payment terms</option>
                                        <option value="net15">Net 15</option>
                                        <option value="net30">Net 30</option>
                                        <option value="net45">Net 45</option>
                                        <option value="net60">Net 60</option>
                                    </select>
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="tax-id">
                                        Tax ID / VAT number
                                    </label>
                                    <input className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500" id="tax-id" type="text" />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-medium mb-2" htmlFor="notes">
                                        Notes
                                    </label>
                                    <textarea className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 h-32" id="notes"></textarea>
                                </div>
                                <div className="mb-4">
                                    <label className="flex items-center">
                                        <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                        <span className="text-gray-700">Mark as preferred supplier</span>
                                    </label>
                                </div>
                                <div className="mb-4">
                                    <label className="flex items-center">
                                        <input type="checkbox" className="rounded text-primary-600 mr-2" />
                                        <span className="text-gray-700">Active supplier</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="border-t p-8 pt-4 flex justify-end space-x-3 bg-white">
                        <Link to="/suppliers" class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-edit-modal">Cancel</Link>
                        <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Save Changes</button>
                    </div>
                </form>
            </main>
        </div>
    )
}
